import { Button, ButtonProps, Text, TextProps, Flex } from '@chakra-ui/react';

interface NavButtonProps extends ButtonProps {
  label: string;
  textProps?: TextProps;
}

export function NavButton({ label, textProps, ...props }: NavButtonProps) {
  return (
    <Button
      maxW={['100%', '350px']}
      h="55px"
      borderRadius="14px"
      bg="white"
      mr="15px"
      justifyContent="flex-start"
      _hover={{
        bg: props.color,
        color: 'white',
      }}
      {...props}
    >
      <Flex align="center" gap={2} color="inherit">
        {props.leftIcon2}

        <Text
          fontSize="18px"
          fontWeight="400"
          textAlign="start"
          color="inherit"
          {...textProps}
        >
          {label}
        </Text>
      </Flex>
    </Button>
  );
}
